import { zodResolver } from "@hookform/resolvers/zod";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@moe/oss/ui/card";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@moe/oss/ui/form";
import { Input } from "@moe/oss/ui/input";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { passwordSchema } from "@web/components/AuthForm";
import { Navbar } from "@web/components/Navbar";
import { sb } from "@web/lib/supabase";
import { useForm } from "react-hook-form";
import { toast } from "sonner";
import { z } from "zod";

export const Route = createFileRoute("/settings/reset-password")({
  component: () => <ResetPassword />
});

const schema = z.object({
  password: passwordSchema,
  confirmation: passwordSchema
});

type Schema = z.infer<typeof schema>;

function ResetPassword() {
  const navigate = useNavigate();

  const form = useForm({
    resolver: zodResolver(schema),
    defaultValues: {
      password: "",
      confirmation: ""
    }
  });

  const onSubmit = async (data: Schema) => {
    if (data.confirmation !== data.password) {
      toast.error("Passwords do not match.");
      return;
    }
    const { error } = await sb.auth.updateUser({
      password: data.password
    });
    if (error) {
      toast.error(error.message);
      console.error(error);
      return;
    }
    toast.success("Password updated successfully!");
    form.reset();
    navigate({ to: "/" });
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key !== "Enter") return;
    e.preventDefault();
    form.handleSubmit(onSubmit)();
  };

  return (
    <div className="bg-background text-tx-secondary flex h-screen w-screen text-sm antialiased">
      <Navbar />
      <button></button>
      <Card className="text-tx-primary m-auto w-96  max-w-lg rounded-3xl py-6">
        <CardHeader>
          <CardTitle className="text-2xl">Reset Passsword</CardTitle>
          <CardDescription className="">Enter your new password below.</CardDescription>
        </CardHeader>
        <CardContent>
          <Form {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)} onKeyDown={handleKeyDown} className="" noValidate>
              <div className="flex flex-col space-y-4">
                <FormField
                  control={form.control}
                  name="password"
                  render={({ field }) => (
                    <FormItem>
                      <div className="flex items-center">
                        <FormLabel>Password</FormLabel>
                      </div>
                      <FormControl>
                        <Input className="bg-input-primary text-tx-primary" type="password" {...field} />
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />
                <FormField
                  control={form.control}
                  name="confirmation"
                  render={({ field }) => (
                    <FormItem>
                      <div className="flex items-center">
                        <FormLabel>Confirm Password</FormLabel>
                      </div>
                      <FormControl>
                        <Input className="bg-input-primary text-tx-primary" type="password" {...field} />
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />
              </div>
            </form>
          </Form>
        </CardContent>
      </Card>
    </div>
  );
}
